import React from "react";

const FavContestListScreen = () => {
	return <h3>FavContestListScreen</h3>;
};

export default FavContestListScreen;
